import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { AttachmentErrorDialogComponent } from 'src/app/grievance/attachment-error-dialog/attachment-error-dialog.component';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Status } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ViewattachmentComponent } from '../../../internal-user/viewattachment/viewattachment.component';
import { ViewAssignedObjectionSuggestionListService } from './view-assigned-objection-suggestion-list.service';
declare var require: any;

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-view-assigned-objection-suggestion-list',
  templateUrl: './view-assigned-objection-suggestion-list.component.html',
  styleUrls: ['./view-assigned-objection-suggestion-list.component.scss'],
})
export class ViewAssignedObjectionSuggestionListComponent implements OnInit {
  myid: any;
  grievanceHistory = [];
  grievanceId: any;
  boardName: any;
  grievanceType: any;
  id: any;
  subject: any;
  remark: any;
  resstatus: any;
  documentList: any = []
  document; any;
  createdOn: any;
  isShowReply: boolean = false;
  docType: string;
  userType: string;
  pkOsid: any;
  departmentName: any;
  osTypeName: string;
  uosType: any
  osSubject: any
  objectionSuggestion: any;
  statusName: any
  replyCtrl = new FormControl();
  userId: any;
  userName: any;
  umobileNo: any;
  uemail: any;
  progressSpinnerDialog: any = null;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;
  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  filenm: any;
  filenm1: any;
  filenm2: any;

  showReply: boolean = false
  firstFormGroup = this._formBuilder.group({
    statusCtrl: [null, [Validators.required]],
    replyCtrl: [null, [Validators.required]],
  })

  protected statuses: Status[] = [];
  public statusCtrl: FormControl = new FormControl();
  public statusFilterCtrl: FormControl = new FormControl();
  public filteredStatus: ReplaySubject<Status[]> = new ReplaySubject<Status[]>(1);

  protected _onDestroy = new Subject<void>();
  osid: any;
  osType: any;
  osHistory: any = [];
  fileBase64: any;
  fileBase1_64: string;
  fileBase2_64: string;
  fileWarningMsg1 = ProjectConstants.uiUploadMax3FilesMsg
  fileWarningMsg2 = ProjectConstants.uiFileExtensionMsg
  fileWarningMsg3 = ProjectConstants.uiFileSizeMsg
  applicationName: any;
  lotteryName: any;
  upan: any=null;
  constructor(public viewassignedOjectionSuggestionReplyService: ViewAssignedObjectionSuggestionListService,
    public router: Router, public _formBuilder: FormBuilder,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    public commonFunction: CommonFunction,
    public activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    //get id through activatedroute
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    this.showFile()
    //load grievance history, statuses, auto scroll history
    this.loadGrievanceHistory();
    this.loadStatus();
    this.scrollToBottom();
    //
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }


  //auto scroll history
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  //


  //on distroy
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  //



  // remove upload
  removeAttachment() {
    if (this.file1 != null) {
      this.file = this.file1
      this.filenm = this.filenm1
      this.fileBase64 = this.fileBase1_64
      if (this.file2 != null) {
        this.file1 = this.file2
        this.filenm1 = this.filenm2
        this.fileBase1_64 = this.fileBase2_64
        this.isShowClose2 = false;
        this.file2 = null
        this.fileBase2_64 = null
        this.filenm2 = null
      } else {
        this.attachments.nativeElement.value = '';
        this.file1 = null
        this.fileBase1_64 = null
        this.filenm1 = null
        this.isShowClose1 = false;
      }
    } else {
      this.attachments.nativeElement.value = '';
      this.file = null
      this.fileBase64 = null
      this.filenm = null
      this.isShowClose = false;
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment1() {
    if (this.file2 != null) {
      this.file1 = this.file2
      this.file2 = null
      this.fileBase1_64 = this.fileBase2_64
      this.fileBase2_64 = null
      this.filenm1 = this.filenm2
      this.filenm2 = null
      this.isShowClose2 = false;
    } else {
      this.attachments1.nativeElement.value = '';
      this.isShowClose1 = false;
      this.file1 = null
      this.filenm1 = null
      this.fileBase1_64 = null
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment2() {
    this.attachments2.nativeElement.value = '';
    this.isShowClose2 = false;
    this.file2 = null
    this.filenm2 = null
    this.fileBase2_64 = null
    this.showFile()
  }
  //

  //file upload 1
  onChange(event) {
    this.file = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file == null) {
            this.isShowClose = false;
            this.filenm = ""
          } else {
            this.filenm = this.file.name
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        } else {
          this.file = null;
          this.isShowClose = false;
          this.filenm = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }
        break;
      default:
        this.file = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file == null) {
            this.isShowClose = false;
          } else {
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        });
    }
  }
  //

  //file upload 2
  onChange1(event) {
    this.file1 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file1 == null) {
            this.isShowClose1 = false;
            this.filenm1 = ""
          } else {
            this.filenm1 = this.file1.name
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        } else {
          this.file1 = null;
          this.isShowClose1 = false;
          this.filenm1 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }
        break;
      default:
        this.file1 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file1 == null) {
            this.isShowClose1 = false;
          } else {
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        });
    }
  }
  //

  //file upload
  onChange2(event) {
    this.file2 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file2 == null) {
            this.isShowClose2 = false;
            this.filenm2 = ""
          } else {
            this.filenm2 = this.file2.name
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        } else {
          this.file2 = null;
          this.isShowClose2 = false;
          this.filenm2 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }
        break;
      default:
        this.file2 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file2 == null) {
            this.isShowClose2 = false;
          } else {
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        });
    }
  }
  //
  showFile() {
    if (this.file == null && this.file1 == null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 == null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 != null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = true;
    }
    else if (this.file != null && this.file1 != null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = false;
    }
  }



  //load status 
  async loadStatus() {
    // this.displayProgressSpinner();
    const response: any = await this.viewassignedOjectionSuggestionReplyService.loadStatus();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.statuses = response
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
    }
  }
  //


  //load grievance history
  async loadGrievanceHistory() {
    this.displayProgressSpinner();
    const response: any = await this.viewassignedOjectionSuggestionReplyService.loadObjectionSuggestionHistoryById(this.id);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        if (response.tabUserObjectionSuggestion.length != 0) {
          this.osid = response.tabUserObjectionSuggestion.pkOsid;
          this.boardName = response.tabUserObjectionSuggestion.boardName;
          this.osType = response.tabUserObjectionSuggestion.objectionSuggestionName;
          this.subject = response.tabUserObjectionSuggestion.osSubject;
          this.remark = response.tabUserObjectionSuggestion.osDetails;
          this.createdOn = response.tabUserObjectionSuggestion.createdOn;
           // if (response.tabUserGrievance.internalUserId == null) {
            this.userId = response.tabUserObjectionSuggestion.fkLotteryUserRegid
          // } else {
          //   this.userId = response.tabUserGrievance.internalUserId
          // }

          this.upan = response.tabUserObjectionSuggestion.historyuserPanNo
          // this.userId=response.tabUserGrievance.
          this.userName=response.tabUserObjectionSuggestion.historyuserName
          // this.umobileNo= this.mask_mobile(response.tabUserObjectionSuggestion.historyuserMobileNo);
          this.umobileNo= response.tabUserObjectionSuggestion.historyuserMobileNo;

          this.uemail=response.tabUserObjectionSuggestion.historyuserEmail
          // this.uemail=this.mask_email(response.tabUserObjectionSuggestion.historyuserEmail)

          // this.osHistory = response.tabOSHistories.sort((a, b) => a.pkOshId > b.pkOshId ? 1 : -1)
          this.osHistory = response.tabOSHistories.map((item) => {
            if (item.ohDocument1 != null) {
              item.ohDocument1 = item.ohDocument1
            }
            if (item.ohDocument2 != null) {
              item.ohDocument2 = item.ohDocument2
            }
            if (item.ohDocument3 != null) {
              item.ohDocument3 = item.ohDocument3
            }
            return item
          })
          this.applicationName = response.tabUserObjectionSuggestion.applicationNo
          this.lotteryName = response.tabUserObjectionSuggestion.lotteryName
          this.resstatus = response.tabUserObjectionSuggestion.statusName;
          this.uosType = response.tabUserObjectionSuggestion.uosType
          if (response.tabUserObjectionSuggestion.osDocument1 != null) {
            this.documentList.push(response.tabUserObjectionSuggestion.osDocument1)
          }
          if (response.tabUserObjectionSuggestion.osDocument2 != null) {
            this.documentList.push(response.tabUserObjectionSuggestion.osDocument2)
          }
          if (response.tabUserObjectionSuggestion.osDocument3 != null) {
            this.documentList.push(response.tabUserObjectionSuggestion.osDocument3)
          }
          if (response.tabUserObjectionSuggestion.fkStid != 10) {
            this.isShowReply = true;
          }
        }
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.authanticationFailedCode) {
          //  this.authErrorToast()
          await this.commonFunction.errorToast(ProjectConstants.authanticationFailedMsg, true, "secure/assigned-objection-suggestion-list")
        }
      }
      else {

        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
      }

    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
    }
  }

  //


  mask_mobile(number) {
    let mask = ''
    if(number!=null){
      for (let i = 1; i <= number.length - 4; i++) {
        mask += '*'
      }
      number = mask + number.slice(6, 10);
  
      return number
    }else{
      return number
    }
   
  }
  // mask_email(mail) {
  //   if(mail!=null){
  //   const [name, domain] = mail.split('@');
  //   const { length: len } = name;
  //   const maskedName = name[0] + '****' + name[len - 1];
  //   const maskedEmail = maskedName + '@' + domain;
  //   return maskedEmail
  //   }else{
  //     return mail
  //   }
  // }

  // reply to assigned grievance
  async replyToCustomer() {
    if (this.uosType == "Objection") {
      if (this.firstFormGroup.controls['replyCtrl'].value && this.firstFormGroup.controls['statusCtrl'].value) {
        if (this.filenm != null) {
          var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
        }
        if (this.filenm1 != null) {
          var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
        }
        if (this.filenm2 != null) {
          var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
        }
        const data = {
          ohRemark: this.firstFormGroup.controls['replyCtrl'].value,
          fkUsOsid: this.id,
          'ohStatusId': this.firstFormGroup.controls['statusCtrl'].value,
          'file1': this.fileBase64,
          'file1Ext': file1_extension,
          'file2': this.fileBase1_64,
          'file2Ext': file2_extension,
          'file3': this.fileBase2_64,
          'file3Ext': file3_extension,
          'file1Name': this.filenm,
          'file2Name': this.filenm1,
          'file3Name': this.filenm2
        }
        this.displayProgressSpinner();
        const response: any = await this.viewassignedOjectionSuggestionReplyService.replyObjectionSuggestion(data);
        this.progressSpinnerDialog.close()
        if (response != null && !response.error) {
          if (response.status == ProjectConstants.responseStatusSuccess) {
            await this.commonFunction.successToast(ProjectConstants.replySucessMsg, false, "")
            this.gotoList()
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
        }
      }
    } else {
      if (this.firstFormGroup.controls['replyCtrl'].value) {
        if (this.filenm != null) {
          var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
        }
        if (this.filenm1 != null) {
          var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
        }
        if (this.filenm2 != null) {
          var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
        }
        const data = {
          ohRemark: this.firstFormGroup.controls['replyCtrl'].value,
          fkUsOsid: this.id,
          // 'ohStatusId': this.firstFormGroup.controls['statusCtrl'].value,
          'file1': this.fileBase64,
          'file1Ext': file1_extension,
          'file2': this.fileBase1_64,
          'file2Ext': file2_extension,
          'file3': this.fileBase2_64,
          'file3Ext': file3_extension,
          'file1Name': this.filenm,
          'file2Name': this.filenm1,
          'file3Name': this.filenm2
        }
        this.displayProgressSpinner();
        const response: any = await this.viewassignedOjectionSuggestionReplyService.replyObjectionSuggestion(data);
        this.progressSpinnerDialog.close()
        if (response != null && !response.error) {
          if (response.status == ProjectConstants.responseStatusSuccess) {
            await this.commonFunction.successToast(ProjectConstants.replySucessMsg, true, "secure/assigned-objection-suggestion-list")
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
        }
      }
    }
  }
  //

  //after reply go to assigned grievance list
  gotoList() {
    this.router.navigate(['secure/assigned-objection-suggestion-list'])
  }
  //

  //view attached document when click on eye icon
  async ViewdownloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.viewassignedOjectionSuggestionReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialog = this.dialog.open(ViewattachmentComponent, {
          disableClose: true,
          width: "600px",
          data: [response.imgResponseString, this.id, this.docType, ghDocument]
        });
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
        }
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
    }
  }
  //
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //download attachment directly
  async downloadAttachment(ghDocument) {
    this.displayProgressSpinner();
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    const response: any = await this.viewassignedOjectionSuggestionReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const byteArray = new Uint8Array(
          atob(response.imgResponseString)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        let blob = new Blob([byteArray], { type: this.docType });
        var src = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = src;
        const date = new Date().toDateString(),
          time = new Date().getTime()
        link.download = this.id + "_" + date + "_" + time +
          '.' + ghDocument.split('.').pop();
        link.click();
        await this.commonFunction.successToast(ProjectConstants.fileSuccessToastMsg, false, "")
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-objection-suggestion-list")
    }
  }
  //


  //base 64 file 1
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase64 = btoa(binaryString);
  }
  //

  //base 64 file 2
  _handleReaderLoaded1(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase1_64 = btoa(binaryString);
  }
  //

  //base 64 file 3
  _handleReaderLoaded2(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase2_64 = btoa(binaryString);
  }


  @ViewChild('pdfTable')
  pdfTable!: ElementRef;
  exportPdf() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download('Objection/Suggestion History Report.pdf');
  }
}
